import { MENU_LCV_SPECIAL_OFFER } from '@/contents/lcv/link';
import { IGenuinePartInfo, IParts } from '@/types/shared/parts';

export const PART_PAGE_METATAG = {
  title: 'ผลิตภัณฑ์และอะไหล่ - อีซูซุประเทศไทย Isuzu Thailand Official',
  description:
    'อะไหล่แท้อีซูซุคุณภาพสูง และอะไหล่แท้ตรีเพชรราคาคุ้มค่า ทุกชิ้นรับประกัน 6 เดือน หรือ 10,000 กม.',
  img: {
    url: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb8ebe5359f8c9db3/62fb311dea0d864c464abcaf/OG_ISUZU.jpg',
  },
};

export const GENUINE_PARTS = {
  isuzuGenuinePart: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt5bef479cfa3504a5/667a3b24c811de1059f5cea3/isuzu-genuine-parts.svg',
    alt: 'Isuzu Genuine Parts',
    dimension: {
      width: 64,
      height: 28,
    },
    dataTrackValue: 'part-item-isuzu',
    type: 'isuzu-logo',
    title: 'อะไหล่แท้อีซูซุ',
    description:
      '<p>คุณภาพเดียวกับอะไหล่ที่ติดตั้งมากับตัวรถ ทดสอบและรับรองโดย บริษัท อีซูซุมอเตอร์ จำกัด (ประเทศญี่ปุ่น)</p>',
  } as IGenuinePartInfo,
  tripetchGenuinePart: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb095c77ba4cee906/667a3b24629cb5e639539cde/tripetch-genuine-parts.svg',
    alt: 'Tri Petch Genuine Parts',
    dimension: {
      width: 156,
      height: 28,
    },
    dataTrackValue: 'part-item-tripetch',
    type: 'tripetch-logo',
    title: 'อะไหล่แท้ตรีเพชร',
    description:
      '<p>อะไหล่ทางเลือกราคาย่อมเยา ทดสอบและรับรองคุณภาพโดยบริษัท ตรีเพชรอีซูซุเซลส์ จำกัด ครอบคลุมงานซ่อมบำรุงกว่า 1,000 รายการ</p>',
  } as IGenuinePartInfo,
  bvpGenuinePart: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt1d18289d1ca21ff2/667a3b24e4222559ad13293f/best-value-parts.svg',
    alt: 'Best Value Parts',
    dimension: {
      width: 64,
      height: 28,
    },
    dataTrackValue: 'part-item-bvp',
    type: 'bvp-logo',
    title: 'อีซูซุเบสท์แวรลู',
    description:
      '<p>อะไหล่ทางเลือกราคาย่อมเยา ทดสอบและรับรองคุณภาพโดยบริษัท อีซูซุมอเตอร์ จำกัด (ประเทศญี่ปุ่น)</p>',
  } as IGenuinePartInfo,
};

export const CHECK_8_SYSTEM: IParts = {
  id: 26,
  image: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltd9ce8295a1427ae5/64ad22f7f122ca1d25e6b8d8/Frame_19294.png',
    alt: 'check out 8 system',
    width: 880,
    height: 1024,
  },
  title: 'ตรวจเช็กรถ 8 ระบบสำคัญ (ครอบคลุม 30 รายการ)',
  remark: `ฟรี`,
  button: {
    url: `${MENU_LCV_SPECIAL_OFFER.url}/service-campaign/freecheck-30-item`,
    label: 'อ่านรายละเอียดเพิ่มเติม',
  },
  table: {
    body: {
      items: [
        {
          item: [
            {
              title: `1.  ระบบเครื่องยนต์`,
            },
          ],
        },
        {
          item: [
            {
              title: `2.  ระบบส่งกำลัง`,
            },
          ],
        },
        {
          item: [
            {
              title: `3.  ระบบบังคับเลี้ยว`,
            },
          ],
        },
        {
          item: [
            {
              title: `4.  ระบบไฟฟ้าและแบตเตอรี่`,
            },
          ],
        },
        {
          item: [
            {
              title: `5.  ระบบช่วงล่าง`,
            },
          ],
        },
        {
          item: [
            {
              title: `6.  ระบบเบรก`,
            },
          ],
        },
        {
          item: [
            {
              title: `7.  ระบบปรับอากาศ`,
            },
          ],
        },
        {
          item: [
            {
              title: `8.  ระบบรักษาความปลอดภัยและอื่นๆ`,
            },
          ],
        },
      ],
    },
  },
  keySystemLayout: true,
};
